import { render, staticRenderFns } from "./AccountingOnboaringComponent.vue?vue&type=template&id=f71b6936&scoped=true"
import script from "./AccountingOnboaringComponent.vue?vue&type=script&lang=js"
export * from "./AccountingOnboaringComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71b6936",
  null
  
)

export default component.exports